import { Box, Skeleton } from '@mui/material';

export default function ContactRowSkeleton() {
    return (
        <Box
            sx={{
                position: 'relative',
                width: '100%',
                marginBottom: '4px',
                padding: '12px 16px',
                display: 'flex',
                alignItems: 'center',
            }}
        >
            {/* Avatar Skeleton */}
            <Box sx={{ mr: 3, flexShrink: 0 }}>
                <Skeleton variant="circular" width={44} height={44} animation="wave" />
            </Box>

            {/* Name Skeleton */}
            <Box sx={{ flex: 1, minWidth: 0 }}>
                <Skeleton variant="text" height={24} width="75%" animation="wave" />
            </Box>
        </Box>
    );
}
